(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list/assets/javascripts/last-row.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list/assets/javascripts/last-row.js');

'use strict';

const helpers = svs.components.lbUtils.helpers;
const _dateFns = dateFns,
  isFuture = _dateFns.isFuture;
const gamesConstants = svs.components.marketplaceData.gamesConstants;
const buyLastText = buyStop => helpers.formatDate.formatDate(buyStop, true, true);
const NoParticipationText = _ref => {
  let buyStop = _ref.buyStop,
    isSubmitted = _ref.isSubmitted,
    gameStatus = _ref.gameStatus,
    canBuy = _ref.canBuy,
    isCurrentUserAuthenticated = _ref.isCurrentUserAuthenticated;
  if (canBuy && !isSubmitted && isFuture(buyStop)) {
    return "K\xF6p senast ".concat(buyLastText(buyStop));
  }
  if (!isCurrentUserAuthenticated) {
    return null;
  }
  const participationText = isSubmitted || gameStatus === gamesConstants.GAME_STATUS_DRAW_CLOSED ? 'deltog' : 'deltar';
  return "Du ".concat(participationText, " inte");
};
const getFractionsText = (currentUserNumberOfShares, isFinished) => {
  let hadOrHave = 'har';
  let shareOrShares = 'andel';
  if (isFinished) {
    hadOrHave = 'hade';
  }
  if (currentUserNumberOfShares > 1) {
    shareOrShares = 'andelar';
  }
  return "Du ".concat(hadOrHave, " ").concat(currentUserNumberOfShares, " ").concat(shareOrShares);
};
const LastRow = _ref2 => {
  let isListing = _ref2.isListing,
    gameStatus = _ref2.gameStatus,
    maxFractions = _ref2.maxFractions,
    buyStop = _ref2.buyStop,
    isFinished = _ref2.isFinished,
    isSubmitted = _ref2.isSubmitted,
    isSoldOut = _ref2.isSoldOut,
    isCurrentUserAuthenticated = _ref2.isCurrentUserAuthenticated,
    isRetail = _ref2.isRetail,
    currentUserNumberOfShares = _ref2.currentUserNumberOfShares;
  if (isListing && isRetail) {
    if (gameStatus === gamesConstants.GAME_STATUS_DRAW_CLOSED) {
      return null;
    }
    return "".concat(maxFractions, " andelar \u2022 ").concat(buyLastText(buyStop));
  }
  if (currentUserNumberOfShares > 0) {
    return getFractionsText(currentUserNumberOfShares, isFinished);
  }
  return React.createElement(NoParticipationText, {
    buyStop: buyStop,
    canBuy: !isSoldOut,
    gameStatus: gameStatus,
    isCurrentUserAuthenticated: isCurrentUserAuthenticated,
    isSubmitted: isSubmitted
  });
};
LastRow.defaultProps = {
  isCurrentUserAuthenticated: true
};
setGlobal('svs.components.marketplace.gameList.LastRow', LastRow);

 })(window);